import {makeStyles} from "@material-ui/core"
import {ModernTheme} from "../../../../../theme/modern/tokens"
import {COARSE, TOUCH_MIN} from "../../../../../theme/modern/touchTargets"

export default makeStyles((theme: ModernTheme) => ({
    banner: {
        display: "flex",
        alignItems: "center",
        gap: "16px",
        background: theme.modern.accentSoft,
        border: `1px solid ${theme.modern.accentLine}`,
        borderRadius: theme.modern.radius,
        padding: "13px 16px",

        "@media (max-width:640px)": {
            flexWrap: "wrap",
            gap: "12px",
        },
    },
    pulseicon: {
        width: 38,
        height: 38,
        flex: "none",
        borderRadius: "50%",
        background: theme.modern.accent,
        color: theme.modern.onAccent,
        display: "grid",
        placeItems: "center",

        "& svg": {width: 20, height: 20},
    },
    info: {
        minWidth: 0,
    },
    microlabel: {
        display: "block",
        font: `600 10px/1 ${theme.modern.sans}`,
        letterSpacing: ".12em",
        textTransform: "uppercase",
        color: theme.modern.accent,
    },
    fname: {
        display: "block",
        font: `600 14px ${theme.modern.mono}`,
        marginTop: 3,
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
        color: theme.modern.ink,
    },
    age: {
        fontWeight: 400,
        color: theme.modern.ink2,

        "&::before": {content: '"\\00a0·\\00a0"'},
    },
    since: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
        font: `400 11px ${theme.modern.mono}`,
        color: theme.modern.ink2,
        marginTop: 4,
        flexWrap: "wrap",
    },
    miniecg: {
        flex: "1 1 0",
        minWidth: 0,
        opacity: .85,
        color: theme.modern.accent,

        "@media (max-width:1180px)": {display: "none"},
    },
    res: {
        display: "inline-flex",
        alignItems: "center",
        gap: "5px",
        font: `700 9.5px ${theme.modern.sans}`,
        letterSpacing: ".07em",
        padding: "2px 9px",
        borderRadius: 999,
        border: "1px solid transparent",
        maxWidth: "100%",
        minWidth: 0,
    },
    res__ok: {
        background: theme.modern.okSoft,
        color: theme.modern.ok,
        borderColor: theme.modern.resOkBorder,
    },
    res__warn: {
        background: theme.modern.warnSoft,
        color: theme.modern.warn,
        borderColor: theme.modern.resWarnBorder,
    },
    res_text: {
        maxWidth: 240,
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
    },
    dot: {
        width: 6,
        height: 6,
        borderRadius: "50%",
        background: "currentColor",
        flex: "none",
    },
    cta: {
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        height: 36,
        padding: "0 16px",
        borderRadius: 8,
        flex: "none",
        marginLeft: "auto",
        background: theme.modern.accent,
        color: theme.modern.onAccent,
        font: `600 13px ${theme.modern.sans}`,
        border: `1px solid ${theme.modern.accent}`,
        cursor: "pointer",

        "&:hover": {filter: "brightness(1.07)"},
        "&:active": {filter: "brightness(.94)"},

        "& svg": {width: 14, height: 14, flex: "none"},

        [COARSE]: {height: "auto", minHeight: TOUCH_MIN, padding: "0 20px"},
    },
}))
